// MODIFIED: Updated relative paths for common components
import { useState, useEffect, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { Input, TextArea } from "../../../../../common/Input";
import { StatusBadge } from "../../../../../common/Badge";

export function ViewEmployeeSARHistoryModal({ isOpen, onClose, employeeSARHistory }) {
  console.log({ employeeSARHistory })

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto">
      <div className="bg-white w-full md:w-[80%] lg:w-[60%] xl:w-[50%] rounded-lg shadow-2xl flex flex-col h-[85vh]">
        <div className="flex justify-between items-center px-6 py-3 border-b bg-gray-50 rounded-t-lg">
          <h2 className="text-lg font-bold text-blue-900 flex items-center gap-2 uppercase">
            <AccountBalanceWalletIcon className="text-blue-700" />
            Employee's Salary Advance History
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-red-500 bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6 bg-white">
          {employeeSARHistory && employeeSARHistory.length > 0 ? (
            <div className="border rounded-lg overflow-hidden shadow-sm">
              <table className="w-full text-left border-collapse">
                <thead className="bg-gray-100 text-gray-600 uppercase text-[11px] font-bold">
                  <tr>
                    <th className="px-4 py-3 border-b">Ref Number</th>
                    <th className="px-4 py-3 border-b">Date</th>
                    <th className="px-4 py-3 border-b text-right">Request Amount</th>
                    <th className="px-4 py-3 border-b text-right">Approved Amount</th>
                    <th className="px-4 py-3 border-b text-right">Remaining Balance</th>
                    <th className="px-4 py-3 border-b text-center">Status</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 text-sm divide-y">
                  {employeeSARHistory.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-4 py-3 font-medium text-blue-800">{item.referenceNumber}</td>
                      <td className="px-4 py-3 text-gray-500">
                        {new Date(item.requestedDate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}
                      </td>
                      <td className="px-4 py-3 text-right font-mono">
                        {item.requestedAmount
                          ? `₱${Number(item.requestedAmount).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                          : <span className="text-gray-300">—</span>}
                      </td>
                      <td className="px-4 py-3 text-right font-mono">
                        {item.approvedAmount
                          ? `₱${Number(item.approvedAmount).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                          : <span className="text-gray-300">—</span>}
                      </td>
                      <td className="px-4 py-3 text-right font-mono">
                        {item.remainingBalance
                          ? `₱${Number(item.remainingBalance).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                          : <span className="text-gray-300">—</span>}
                      </td>
                      
                      <td className="px-4 py-3 text-center">
                        <StatusBadge status={item.status} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="h-full flex flex-col items-center justify-center text-gray-400 space-y-2">
              <DescriptionIcon sx={{ fontSize: 48 }} className="opacity-20" />
              <p className="italic">No previous salary advance history found.</p>
            </div>
          )}
        </div>

        <div className="p-4 border-t bg-gray-50 flex justify-end items-center rounded-b-lg">
          <button onClick={onClose} className="px-8 py-2 bg-gray-400 text-white rounded font-bold cursor-pointer border-none text-sm hover:bg-gray-500">Close</button>
        </div>
      </div>
    </div>
  );
}